import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LocalStorage } from '../utils/LocalStorage';
import './FreeTrialBanner.scss';

const FREE_TRIAL_STATUS = 'Free Trial';
const MAX_DAYS_TO_SHOW = 5;
const REFRESH_INTERVAL_MS = 5000;

export const FreeTrialBanner = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [daysRemaining, setDaysRemaining] = useState(null);
    const [agencyStatus, setAgencyStatus] = useState(null);

    useEffect(() => {
        const readFromStorage = () => {
            setDaysRemaining(LocalStorage.fetchFreeTrialDaysRemaining());
            setAgencyStatus(LocalStorage.fetchAgencyStatus());
        };

        readFromStorage();
        const interval = setInterval(readFromStorage, REFRESH_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    const shouldShow = agencyStatus === FREE_TRIAL_STATUS
        && daysRemaining !== null
        && daysRemaining <= MAX_DAYS_TO_SHOW;

    if (!shouldShow) return null;

    const getMessage = () => {
        if (daysRemaining === 0) return t('free_trial_banner.message_0');
        if (daysRemaining === 1) return t('free_trial_banner.message_1');
        return t('free_trial_banner.message', { days: daysRemaining });
    };

    const handleCtaClick = () => {
        navigate('/agency/subscription');
    };

    return (
        <div className="free-trial-banner">
            <div className="free-trial-banner-content">
                <span className="free-trial-banner-text">{getMessage()}</span>
                <button className="free-trial-banner-cta" onClick={handleCtaClick}>
                    {t('free_trial_banner.cta')}
                </button>
            </div>
        </div>
    );
};
